module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "card card-blosq card-active"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/agentservices/shopaccounts"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Shop Accounts")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.agent_services_numbers.data_businesses_count && (_vm.agent_services_numbers.data_businesses_count > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.agent_services_numbers.data_businesses_count) + ")")]) : _c('span', [_vm._v("(0)")]), _vm._v("   "), _c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.agent_services_numbers.data_productss_count && (_vm.agent_services_numbers.data_products_count > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.agent_services_numbers.data_orders_count) + ")")]) : _c('span', [_vm._v("(0)")]), _vm._v("   "), _c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.agent_services_numbers.data_orders_count && (_vm.agent_services_numbers.data_orders_count > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.agent_services_numbers.data_orders_count) + ")")]) : _c('span', [_vm._v("(0)")]), _vm._v("   "), _c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbcff176"}!./src/pages/AgentServices/AddedServices/template.html
// module id = 640
// module chunks = 0